import React from 'react';
import { Stack, Step, StepLabel, Stepper, Typography } from '@mui/material';
import moment from 'moment';
import { Box } from '@mui/system';
export function StepperComponent({ steps, activeStep, avatar }) {
    return (<Stepper activeStep={activeStep} alternativeLabel sx={{ m: 2 }}>
      {steps.map(s => (<Step key={s.id}>
          <StepLabel>
            <Stack spacing={1} direction='column' alignItems='center' justifyContent='center'>
              <Box>{s.designacao}</Box>

              <Typography variant='caption' gutterBottom sx={{ display: 'block' }}>
                {s.pessoa}
              </Typography>

              <Typography variant='caption' gutterBottom sx={{ display: 'block' }}>
                {s.data && s.id - 1 != activeStep ? moment(s.data).format('DD-MM-YYYY') : ''}
              </Typography>
            </Stack>
          </StepLabel>
        </Step>))}
    </Stepper>);
}
